import { FormValues } from '@wix/form-viewer';
import { WixFormsFieldProperties } from '../state/types';

const isFieldFilled = (value: unknown): boolean => {
  if (value === undefined || value === null || value === '') {
    return false;
  }
  if (typeof value === 'object') {
    return Object.keys(value as object).length > 0;
  }
  return true;
};

export const getRequiredFieldIds = (
  fieldProperties: WixFormsFieldProperties = {},
): string[] =>
  Object.entries(fieldProperties)
    .filter(([, props]) => props.required && !props.hidden)
    .map(([fieldId]) => fieldId);

export const getFirstIncompleteParticipantIndex = (
  participantForms: FormValues[],
  requiredFieldIds: string[],
): number =>
  participantForms.findIndex(
    (values) =>
      !requiredFieldIds.every((fieldId) => isFieldFilled(values?.[fieldId])),
  );
